import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const ErrorWrapper = styled.div<{ $globalError: boolean }>`
  &&& {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${({ $globalError }) =>
      $globalError
        ? css`
            align-items: center;
            flex-direction: column;
            justify-content: center;
            min-height: ${pxToRem(350)};
          `
        : css`
            svg {
              margin-right: ${pxToRem(8)};
            }
          `}
  }
`;

export const ErrorSpan = styled.span`
  &&& {
    margin: 0 ${pxToRem(5)};
  }
`;
